export default {
	name: 'final',
	description: 'Конец раунда',
	title: 'Перерыв',
	minigameType: 'Final',
	generateParams(minigame, state) {
		let curHistory = state.objects.history;
		const revHistory = curHistory.slice().reverse();
		let roundHistory;
		let res = revHistory.findIndex(elem => elem.minigame.name === "count-rest");
		if(res === -1) {
			roundHistory = revHistory.slice().reverse();
		}
		else {
			roundHistory = revHistory.slice(0, res);
		}
		roundHistory = roundHistory.filter(elem => elem.minigame.minigameType !== "Intro" && elem.minigame.minigameType !== "Final" && elem.minigame.minigameType !== "End" && elem.minigame.minigameType !== "Greeting");
		return { history: state.objects.history, roundHistory: roundHistory };
	},
	isCompleted: () => true,
	score: 0,
};
